import * as yup from 'yup'


const MaterialManufactureValidationSchema = yup.object().shape({
    selectedCreatedMaterialId: yup.string().required('This field is required.'),
    warehouseId: yup.string().required('This field is required.')
})

const materialManufactureInitialState = {
    selectedCreatedMaterialId: '',
    selectedWarehouseId: '',
}

export { MaterialManufactureValidationSchema, materialManufactureInitialState };